import React from 'react'

const UpdateGeneratePaybill = () => {
  return (
    <div>UpdateGeneratePaybill</div>
  )
}

export default UpdateGeneratePaybill